
import COVERAPP from '@/utils/COVERAPP';
import { ref } from 'vue'
import { Options, Vue } from 'vue-class-component'
import { mapState } from 'vuex'
import Xiaofeng from '../components/Xiaofeng.vue'

let isInput = false;
@Options({
  data() {
    return {
      propose: '',
      list: [],
      dmLayerRandom: [],
      focus: false,
    };
  },
  components: {
    Xiaofeng,
  },
  computed: {
    ...mapState(['aid', 'userInfo', 'shareData', 'activityData'])
  },
  mounted () {
    this.$common.pageLoaded()
    this.$common.track('load', '进入我要建议页')
    this.getList()
    const shareData = JSON.parse(JSON.stringify(this.shareData))
    this.$common.onshare(shareData)
  },
  methods: {
    async getList() {
      let likes: any = new Set();
      try {
        let ids = localStorage.getItem('2024sclh_like') || '';
        ids = JSON.parse(ids) || [];
        likes = new Set(ids);
      } catch (e) {

      }

      const res = await this.$request('/vote', {
        aid: this.aid,
        rows: 1000,
        field: 'type',
        keyword: 'propose'
      });

      const list = res.list || [];
      let contents: any = [];

      list.forEach(item => {
        contents.push({
          id: item.id,
          info: item.info.title,
          like: item.votes || 0,
          color: [Math.floor(Math.random() * 80) + 90, Math.floor(Math.random() * 5) / 10 + 0.2],
          isLike: likes.has(item.id) || false,
        });
      });

      // 根据字数多少进行排序
      contents.sort((a, b) => {
        return a.info.length - b.info.length;
      });

      // 对数组中的内容平均分为5组
      const partSize = Math.floor(contents.length / 5);
      const data: any = [];
      for (let i = 0; i < contents.length; i += partSize) {
        data.push(contents.slice(i, i + partSize));
      }

      // 对data数据的每个分组内的内容进行随机排序
      for (let i = 0; i < data.length; i++) {
        this.dmLayerRandom.push([Math.floor(Math.random() * 100) + 100 + 7 * i, Math.floor(Math.random() * 100) + 50]);  // 固定随机数，避免视图重新渲染影响显示
        data[i] = data[i].sort(() => Math.random() - 0.5);
      }

      this.list = data;
    },
    async submit() {
      const _this = this;
      if (isInput) {
        return;
      }
      const input = this.propose;
      console.log(input);

      if (!this.userInfo.token) {
        this.$common.toast('登录失效~');
        this.$router.push('/');
        return;
      }

      if (!input) {
        this.$common.toast('请输入建议内容！');
        this.$refs.input.focus();
        return;
      }

      this.$common.track('submit', '提交建议');
      isInput = true;

      this.$request('/apply', {
        info: {
          type: 'propose',
          title: input,
        },
        token: this.userInfo.token,
        userinfo: this.userInfo,
        aid: this.aid,
      }, 'post').then(res => {
        isInput = false;
        _this.propose = '';
        _this.$common.toast('提交成功！');
      }).catch(e => {
        _this.$common.toast('网络错误~');
        isInput = false;
        return;
      });
    },
    handleFocus() {
      if (COVERAPP.Attribute.isAndroid()) {
        this.focus = true;
      }
    },
    async handleLike(id, position) {
      if (!this.userInfo.token) {
        this.$common.toast('登录失效~');
        this.$router.push('/');
        return;
      }

      await this.$request('/vote', {
        aid: this.aid,
        uid: this.userInfo.token,
        vid: id,
        userinfo: this.userInfo,
      }, 'post').catch(e => {});

      this.list[position[0]][position[1]].isLike = true;
      this.list[position[0]][position[1]].like += 1;
      try {
        let likes: any = localStorage.getItem('2024sclh_like') || '';
        if (likes) {
          likes = JSON.parse(likes) || [];
        }
        likes = new Set(likes || []);
        likes.add(id);
        localStorage.setItem('2024sclh_like', JSON.stringify(Array.from(likes)));
      } catch (e) {
        console.log(e);
      }
    },
  },
})
export default class Propose extends Vue {}
